import React, { createContext, useState, useContext } from "react";
import {CMSContext} from "./CMSContext";
import useCMS from "../hooks/useCMS";
import useLog from "../hooks/useLog";
import { ACSContext } from "./ACSContext";
import useACS from "../hooks/useACS";

// a user context that will be used to store the user data
export const UserContext = createContext();
  
  const UserProvider = ({ children }) => {
    const [userInfo, setUserInfo] = useState(JSON.parse(localStorage.getItem('user')));
    const [email, setEmail] = useState('');
    const [userId, setUserId] = useState('');
    const [loggedInState, setLoggedInState] = useState("Loading");//Loading, Unauthenticated, GoogleAuthenticated, CMSAuthenticated, Error
    const [loginMethod, setLoginMethod] = useState(null);//google, phone
    const [authenticationExpiration, setAuthenticationExpiration] = useState(null);
    const { LogInfo } = useLog();
    const { clearAllCMSData, setToken: setCMSToken } = useContext(CMSContext);
    const {setCallAgent} = useContext(ACSContext);
    const { GetTokenForUser } = useCMS();
    const {initializeACS} = useACS();

    const readToken = (user) => {
      setEmail(user.email);
      setUserId(user.sub);
      setUserInfo(user);
      setAuthenticationExpiration(user.exp);
      setLoggedInState('GoogleAuthenticated');
    }

    const login = async (user) => {
        //called from login component when Google resposne is received
        LogInfo("logging in with user " + JSON.stringify(user));
        readToken(user);
        setLoggedInState('GoogleAuthenticated');
        setLoginMethod('google');
        localStorage.setItem('user', JSON.stringify(user));

        //if the user is authenticated, get the token for the user
        LogInfo('login: getting token for user ' + user.sub);
        const token = await GetTokenForUser(user.sub);
        if (token) {
          LogInfo('login: Token received, setting Logged in state to CMSAuthenticated');
          setLoggedInState('CMSAuthenticated');
          const success = await initializeACS(token, user.sub);
          if(success) {
            LogInfo('login: ACS initialized successfully');
          }
          return success;
        } else {
          LogInfo('login: Failed to get token, setting Logged in state to Unauthenticated');
          logout();
          return false;
        }
      }

      const loginWithPhone = async (details, phoneNumber) => {
        //called from login component once validateSignnCode returns a JWT for the phone number
        LogInfo('logging in with phone user ' + phoneNumber);
        setEmail(details.email || '');
        setUserId(phoneNumber);
        setUserInfo(details);
        setAuthenticationExpiration(details.exp);
        setLoginMethod('phone');
        localStorage.setItem('user', JSON.stringify(details));

        //fetch building/device data for the guard; GetTokenForUser also returns the real ACS token to use for calling
        LogInfo('loginWithPhone: getting building data for phone user ' + phoneNumber);
        const acsToken = await GetTokenForUser(null, phoneNumber);
        if (acsToken) {
          setCMSToken(acsToken);
          LogInfo('loginWithPhone: building data received, setting Logged in state to CMSAuthenticated');
          setLoggedInState('CMSAuthenticated');
          const success = await initializeACS(acsToken, null, phoneNumber);
          if (success) {
            LogInfo('loginWithPhone: ACS initialized successfully');
          }
          return success;
        } else {
          LogInfo('loginWithPhone: Failed to get building data, setting Logged in state to Unauthenticated');
          logout();
          return false;
        }
      }

      const logout = () => {
        LogInfo('logging out');
        setUserInfo(null);
        setUserId('');
        setLoginMethod(null);
        localStorage.removeItem('user');
        setLoggedInState('Unauthenticated');
        clearAllCMSData();
        setCallAgent(null);
      }

    return (
        <UserContext.Provider value={{ userInfo, setUserInfo, login, loginWithPhone, logout,userId, setUserId,email, loggedInState, setLoggedInState, loginMethod }}>
        {children}
        </UserContext.Provider>
    );
    };
export { UserProvider };